import i18next from 'i18next';

/**
 * The builtin languages.
 */
const _LANGUAGES = {

    // Basque
    'eu': {
        main: require('../../lang/main-eu.json')
    },

    // Bulgarian
    'bg': {
        main: require('../../lang/main-bg.json')
    },

    // Catalan
    'ca': {
        main: require('../../lang/main-ca.json')
    },

    // Danish
    'da': {
        main: require('../../lang/main-da.json')
    },

    // Dutch
    'nl': {
        main: require('../../lang/main-nl.json')
    },

    // Estonian
    'et': {
        main: require('../../lang/main-et.json')
    },

    // French
    'fr': {
        main: require('../../lang/main-fr.json')
    },

    // Finnish
    'fi': {
        main: require('../../lang/main-fi.json')
    },

    // German
    'de': {
        main: require('../../lang/main-de.json')
    },

    // Italian
    'it': {
        main: require('../../lang/main-it.json')
    },

    // Portuguese
    'pt': {
        main: require('../../lang/main-pt.json')
    },

    // Spanish
    'es': {
        main: require('../../lang/main-es.json')
    },

    // Spanish (Latin America)
    'esUS': {
        main: require('../../lang/main-esUS.json')
    },

    // Swedish
    'sv': {
        main: require('../../lang/main-sv.json')
    }
};

// Register all builtin languages with the i18n library.
// eslint-disable-next-line
for (const name in _LANGUAGES) {
    const { main } = _LANGUAGES[name];

    i18next.addResourceBundle(
        name,
        'main',
        main,
        /* deep */ true,
        /* overwrite */ true);
}
